import React, { useState, useContext } from "react";
import "./ResetPassword.css";
import { MyContext } from "../../../../Context/MyContext";
import API from "../../../../Api/api";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPasswordAuth = ({ setActiveTab }) => {
  const { logininput } = useContext(MyContext);
  const safeReset = logininput?.reset_password || [];

  const [formData, setFormData] = useState({ new_password: "", confirm_password: "" });
  const [showPass,  setShowPass]  = useState(false);
  const [showCPass, setShowCPass] = useState(false);
  const [loading,   setLoading]   = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    for (let item of safeReset) {
      if (item.isrequired && !formData[item.field]) { toast.error(`${item.name} is required!`); return; }
    }
    if (formData.new_password !== formData.confirm_password) { toast.error("Passwords must match!"); return; }

    const email = localStorage.getItem('reset_email');
    if (!email) { toast.error("Session expired. Please try again."); setActiveTab("forgot_password"); return; }

    setLoading(true);
    try {
      await API.post('/auth/reset-password', {
        email,
        new_password: formData.new_password,
      });
      toast.success("Password Reset Successful!");
      localStorage.removeItem('reset_email');
      setActiveTab("login");
    } catch (err) {
      toast.error(err.response?.data?.error || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="reset-container">
      <form className="reset-form" onSubmit={handleSubmit}>
        <h2 className="reset-title">Reset Password</h2>
        <p className="reset-subtitle">Enter new password and confirm.</p>
        <div className="input-group">
          <label>Enter new password</label>
          <div className="input-wrapper">
            <input type={showPass?"text":"password"} name="new_password"
              value={formData.new_password} onChange={handleChange} placeholder="Enter new password"/>
            <span className="eye-icon" onClick={() => setShowPass(!showPass)}>
              {showPass ? <FaEyeSlash/> : <FaEye/>}
            </span>
          </div>
        </div>
        <div className="input-group">
          <label>Confirm new password</label>
          <div className="input-wrapper">
            <input type={showCPass?"text":"password"} name="confirm_password"
              value={formData.confirm_password} onChange={handleChange} placeholder="Confirm new password"/>
            <span className="eye-icon" onClick={() => setShowCPass(!showCPass)}>
              {showCPass ? <FaEyeSlash/> : <FaEye/>}
            </span>
          </div>
        </div>
        <button type="submit" className="reset-btn" disabled={loading}>
          {loading ? "Resetting…" : "Reset Password"}
        </button>
        <p className="back-login-text">Back to <span onClick={() => setActiveTab("login")}>Login</span></p>
      </form>
    </div>
  );
};

export default ResetPasswordAuth;